<template lang="pug">
.comAll(v-dragDiv, v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{ actionData.cnName }}
    i.el-icon-minus.minibtn(title="最小化", @click="miniCom")
    i.el-icon-close(title="关闭", @click="closeAdd")
  .btn-list(v-if="supported")
    el-button(v-if="!isActive", type="primary", @click="start") 开始录制
    el-button(v-else, type="danger", @click="stop") 结束录制
  .video-search
    el-input(v-model="searchForm.videoFileName", placeholder="请输入视频名称搜索", clearable, prefix-icon="el-icon-search", size="small", @change="getList")
  .video-list
    img.empty(v-if="!list.length", src="./assets/empty.jpg")
    .video-item(v-for="row in list", :key="row.id", @click="openVideo(row)")
      .video-cover
        img.cover(:src="row.coverImageId | href")
        img.cover-icon(src="./assets/video-play.svg")
      .video-footer
        .video-info
          .video-title {{ row.videoFileName }}
          .video-date {{ row.uploadDate }}
        .video-opr
          i.el-icon-delete.delete(@click.stop="deleteVideo(row)")
  el-dialog(v-draggable, width="650px", :title="dialogTitle", append-to-body, :visible.sync="dialog.visible", :close-on-click-modal="false", @closed="detailClosed")
    el-form(ref="form", :model="form", :rules="rules", size="small", label-width="100px", label-position="left")
      el-form-item(label="录制视频：")
        .video-block
          el-progress(v-if="dialog.showPercentage", :show-text="false", :stroke-width="2", :percentage="dialog.percentage")
          video(:src="dialog.source", controls)
      el-form-item(prop="videoFileName", label="视频名称：", :maxlength="50", show-word-limit)
        el-input(v-model="form.videoFileName", placeholder="请输入视频名称")
      el-form-item(prop="remark", label="介绍：")
        el-input(v-model="form.remark", :rows="4", placeholder="请输入简介", type="textarea", resize="none", :maxlength="50", show-word-limit)
    template(#footer)
      el-button(@click="closeDialog") 关闭
      el-button(v-if="!dialog.state", type="primary", @click="submit") 添加
      el-button(v-else, type="primary", @click="submitEdit") 修改
</template>

<script>
import { modelVideoFileDelete, modelVideoFileEdit, modelVideoFileList, modelVideoFileSave } from "./api.js";
import { useCanvasRecorder } from "./recorder.js";
import axios from "@/CommonDP/utils/request";
import { getToken } from "@/CommonDP/mongeView/utils";
import env from "@/CommonDP/utils/env.js";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";

const { start, stop, cancel, supported } = useCanvasRecorder();
function href(fileId = "") {
  return env.VUE_APP_API + `/files/download/${fileId}?token=${getToken()}`;
}
export default {
  filters: { href },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {},
      list: [],
      supported,
      isActive: false,
      searchForm: { videoFileName: "" },
      rules: {
        videoFileName: { required: true, message: "视频名称不得为空" }
      },
      dialog: {
        state: 0, // 0 创建 1查看 2修改
        title: "创建漫游动画",
        visible: false,
        source: null,
        blob: null,
        showPercentage: false,
        percentage: 0
      }
    };
  },
  computed: {
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    fileId() {
      if (this.modelInfoData.fileObj) {
        return this.modelInfoData.fileObj.map(e => e.folderID).join();
      } else {
        return this.modelInfoData.fileId;
      }
    },
    fileName() {
      if (this.modelInfoData.fileObj) {
        return this.modelInfoData.fileObj.map(e => e.folderName).join();
      } else {
        return this.modelInfoData.fileName;
      }
    },
    version() {
      if (this.modelInfoData.fileObj) {
        return this.modelInfoData.fileObj.map(e => e.rvtVersion).join();
      } else {
        return this.modelInfoData.rvtVersion;
      }
    },
    prjId() {
      return this.modelInfoData.prjId;
    },
    dialogTitle() {
      return !this.dialog.state ? "创建录制" : "录制详情";
    }
  },
  created() {
    this.getList();
  },
  destroyed() {
    if (this.isActive) {
      cancel();
      this.$message.warning("录制已取消");
    }
  },
  methods: {
    openVideo(form) {
      this.dialog.state = 2;
      this.form = form;
      this.dialog.showPercentage = false;
      this.dialog.source = href(form.videoFileId);
      this.dialog.visible = true;
    },
    newData(data) {
      return {
        coverImageId: "",
        modelFileId: "",
        modelFileName: "",
        modelFileVersion: 0,
        prjId: "",
        remark: "",
        videoFileId: "",
        videoFileName: "",
        videoFileSize: 0,
        ...data
      };
    },
    async uploadPic() {
      const { form } = this;
      const rawCanvas = this.getCanvas();
      // 制作处理缩略图
      const { height: rH, width: rW } = rawCanvas;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const radio = Math.min(140 / rH, 240 / rW);
      const height = ~~(rH * radio);
      const width = ~~(rW * radio);
      canvas.height = height;
      canvas.width = width;
      context.drawImage(rawCanvas, 0, 0, rW, rH, 0, 0, width, height);
      // 截图并保存
      const { fileKey: coverImageId } = await new Promise((resolve, reject) => {
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(this.uploadFile(blob));
            } else {
              reject();
            }
          },
          "image/jpg",
          0.5
        );
      });
      form.coverImageId = coverImageId;
      // 销毁缩略图
      canvas.remove();
    },
    async uploadVideo() {
      const {
        form,
        dialog,
        dialog: { blob }
      } = this;
      const { fileKey: videoFileId } = await this.uploadFile(blob, (e) => {
        dialog.percentage = (e.total / e.loaded) * 100 || 0;
      });
      form.videoFileId = videoFileId;
    },
    async uploadFile(file, onUploadProgress) {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios({
        method: "POST",
        url: "/common/upload",
        data: formData,
        onUploadProgress
      });
      return data;
    },
    async submit() {
      const { form, dialog } = this;
      await this.$refs.form.validate();
      const reqList = [];
      form.coverImageId || reqList.push(this.uploadPic());
      form.videoFileId || reqList.push(this.uploadVideo());
      await Promise.all(reqList);
      dialog.showPercentage = false;
      await modelVideoFileSave(form);
      this.$message.success("提交成功");
      this.dialog.visible = false;
      this.getList();
    },
    async submitEdit() {
      const { form, dialog } = this;
      await this.$refs.form.validate();
      await modelVideoFileEdit({
        id: form.id,
        remark: form.remark,
        videoFileName: form.videoFileName
      });
      dialog.visible = false;
      this.$message.success("提交成功");
      this.getList();
    },
    async getList() {
      const params = {
        modelFileId: this.fileId,
        // prjId: this.prjId,
        videoFileName: this.searchForm.videoFileName
      };
      const { data } = await modelVideoFileList(params);
      this.list = data || [];
    },
    async deleteVideo(row) {
      await this.$confirm("确定删除?", "警告", { type: "warning" });
      await modelVideoFileDelete({ batchIdList: [row.id] });
      this.$message.success("删除成功");
      this.getList();
    },
    // 获取 canvas
    getCanvas() {
      return document.querySelector("#modelbox canvas");
    },
    // 开始录制
    async start() {
      const { fileId: modelFileId, fileName: modelFileName, prjId, version: modelFileVersion } = this;
      this.isActive = true;
      const msg = this.$message({ type: "success", message: "已开始录制,点击结束录制结束录制", duration: 0 });
      const canvas = this.getCanvas();
      const recorder = start(canvas).finally(() => {
        this.isActive = false;
        msg.close();
      });
      const blob = await recorder;
      this.isActive = false;
      const src = URL.createObjectURL(blob);
      this.dialog.state = 0;
      this.form = this.newData({ modelFileId, modelFileName, prjId, modelFileVersion, videoFileSize: blob.size });
      this.dialog.source = src;
      this.dialog.percentage = 0;
      this.dialog.showPercentage = true;
      this.dialog.blob = blob;
      this.dialog.visible = true;
    },
    // 结束本次录制
    stop() {
      stop();
      this.$message.success("录制已完成");
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    detailClosed() {
      this.dialog.blob = null;
      URL.revokeObjectURL(this.dialog.source);
    },
    miniCom() {
      this.$emit("closeCom", "recorder", true);
    },
    closeAdd() {
      this.$emit("closeCom", "recorder", false);
    }
  }
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
